// extracted by mini-css-extract-plugin
export var container = "O1sXnU9s";
export var container__shown = "AuT58zni";
export var footer = "-k1Qcsgb";
export var items = "fTPbKU4H";
export var text = "N9JrZlw2";
export var item = "_9pDYcn5Q";
export var register = "_1SuIsQ4i";
export var register__disabled = "CTsKK9YY";